import React from "react";

import { useUpdateDocScanFieldReview } from "utils";

import { GetFarmDocScanFieldResponse } from "models";

import { Button, Form, Message, Radio, TextArea, Typography } from "components";

type ReviewChoice = "correct" | "wrong";

type ReviewFormValues = { choice?: ReviewChoice; comment?: string };

type DocScanFieldReview = GetFarmDocScanFieldResponse["review"];

type DocScanReviewProps = {
  farmId: string;
  scanFieldId: string;
  scanId: string;
  review: DocScanFieldReview;
};

const toReviewChoice = (isCorrect: boolean | null): ReviewChoice | undefined => {
  if (isCorrect === null) return undefined;
  return isCorrect ? "correct" : "wrong";
};

export const DocScanReview = ({ farmId, scanFieldId, scanId, review }: DocScanReviewProps) => {
  const [form] = Form.useForm<ReviewFormValues>();
  const { mutate: saveReview, isPending } = useUpdateDocScanFieldReview({ farmId, scanFieldId });

  const handleFinish = ({ choice, comment }: ReviewFormValues) =>
    saveReview(
      { scanId, isCorrect: choice ? choice === "correct" : null, comment: comment?.trim() || null },
      { onSuccess: () => Message({ icon: "tick", content: "Review saved" }) }
    );

  return (
    <div className="doc-scan-review">
      <Typography variant="paragraph-m" color="grey-600">
        Review
      </Typography>
      <div>
        <Typography variant="paragraph-m" bold className="doc-scan-review-question">
          Is this match correct?
        </Typography>
        <Form form={form} layout="vertical" initialValues={{ choice: toReviewChoice(review.isCorrect) }} onFinish={handleFinish}>
          <Form.Item name="choice">
            <Radio.Group className="doc-scan-review-choices">
              <Radio value="correct">Correct</Radio>
              <Radio value="wrong">Wrong</Radio>
            </Radio.Group>
          </Form.Item>
          <TextArea name="comment" label="Comment (optional)" rows={3} initialValue={review.comment ?? ""} />
          <div className="doc-scan-review-actions">
            <Button type="primary" htmlType="submit" className="doc-scan-review-button" loading={isPending}>
              Save review
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};
